export const getFollowingMonth = (date: string) => {
  const _date = new Date(date);
  const monthId = _date.getMonth();
  const followingMonth =
    monthId + 2 < 10 ? `0${monthId + 2}` : String(monthId + 2);
  const isLastMonthOfYear = monthId === 11;
  const year = new Date(date).getFullYear();

  if (isLastMonthOfYear) {
    return `${year + 1}-01-01`;
  } else {
    return `${year}-${followingMonth}-01`;
  }
};
